import {Pipe, PipeTransform} from '@angular/core';
import {DecimalPipe} from "@angular/common";

@Pipe({
  name: 'raceLengthFormat'
})
export class RaceLengthFormatPipe implements PipeTransform {

  constructor(private decimalPipe: DecimalPipe) {
  }

  transform(length: number | string | undefined, activeLang: string, unit?: "km" | "m" | undefined, withUnit: boolean = true): string | undefined {
    if (length !== undefined && length !== null && typeof Number(length) === "number") {
      return this.getRaceLength(Number(length), activeLang, unit, withUnit);
    }
    return "";
  }

  getRaceLength(length: number | undefined, activeLang: string, unit: "km" | "m" = "km", withUnit: boolean = true): string {
    if (length == null || isNaN(length)) return "";

    let displayValue: number;
    let displayUnit: string;

    if (unit === "km") {
      displayValue = length;
      displayUnit = "km";
      if (length < 1) {
        displayValue = length * 1000;
        displayUnit = "m"
      }
    } else {
      if (length >= 1000) {
        displayValue = length / 1000;
        displayUnit = "km";
      } else {
        displayValue = length;
        displayUnit = "m";
      }
    }

    const formatted = this.decimalPipe.transform(displayValue.toFixed(1), '1.0-1', activeLang);
    return formatted + (withUnit ? ` ${displayUnit}` : "");
  }

}
